import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { useComplementaryOptionsGenerator } from '../../../_helpers/complementaryOptions'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import PlaceLevelInputs from './placeLevels/PlaceLevelInputs'
import PlaceTypeSelect from '../../../../../../containers/places/select/PlaceTypeSelect'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'

const InsertPlaceSentence = () => {
  const [open, setOpen] = React.useState()
  const { t } = useTranslation('triggers')
  const { handleChangeIn, form } = useFormState()
  const getComplementaryOptions = useComplementaryOptionsGenerator()

  return (
    <>
      <Text size="h2">: </Text>
      <EditableSentence
        label={form.payload?.name || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Grid paddingGutter={0.5} wrap>
          <Col width="50%">
            <FormItem label={t('insertPlace.typeRequired')} path={['payload', 'type']} Input={PlaceTypeSelect} />
          </Col>

          <PlaceLevelInputs />
        </Grid>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default InsertPlaceSentence
